import * as React from 'react';

interface CircledCheckmarkProps {
    className?: string;
}

export const CircledCheckmark: React.SFC<CircledCheckmarkProps> = ({ className }) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="24.851" 
        height="24.851" 
        viewBox="0 0 24.851 24.851"
        className={className}
    >
        <g id="check_mark" data-name="check mark" transform="translate(-2.875 -2.875)">
            <path 
                id="Path_485" 
                data-name="Path 485" 
                d="M22.715,13.313l-1.009-1.038a.217.217,0,0,0-.161-.069h0a.208.208,0,0,0-.161.069L14.39,19.321l-2.546-2.546a.222.222,0,0,0-.321,0L10.5,17.8a.228.228,0,0,0,0,.327l3.211,3.211a1.015,1.015,0,0,0,.671.327,1.064,1.064,0,0,0,.665-.315h.006l7.665-7.706A.245.245,0,0,0,22.715,13.313Z" 
                transform="translate(-1.303 -1.63)" 
                fill="currentColor" 
                stroke="currentColor" 
                strokeWidth="1"
            />
            <path 
                id="Path_486" 
                data-name="Path 486" 
                d="M15.3,4.98A10.316,10.316,0,1,1,8,8,10.252,10.252,0,0,1,15.3,4.98m0-1.605A11.925,11.925,0,1,0,27.226,15.3,11.923,11.923,0,0,0,15.3,3.375Z" 
                fill="currentColor" 
                stroke="currentColor" 
                strokeWidth="1"
            />
        </g>
    </svg>
);



// WEBPACK FOOTER //
// ./src/components/common/CircledCheckmark.tsx